const STORAGE_KEY = "planAccessCodes";

const readCodes = () => {
  if (typeof window === "undefined") return {};
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object") {
      return parsed;
    }
  } catch (err) {
    console.warn("Не удалось прочитать коды доступа планов", err);
  }
  return {};
};

const writeCodes = (codes) => {
  if (typeof window === "undefined") return;
  try {
    const keys = Object.keys(codes || {});
    if (keys.length === 0) {
      window.localStorage.removeItem(STORAGE_KEY);
    } else {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(codes));
    }
  } catch (err) {
    console.warn("Не удалось сохранить коды доступа планов", err);
  }
};

export const getPlanAccessCode = (uuid) => {
  if (!uuid) return null;
  const codes = readCodes();
  return codes[uuid] || null;
};

export const setPlanAccessCode = (uuid, code) => {
  if (!uuid || !code) return;
  const codes = readCodes();
  codes[uuid] = code;
  writeCodes(codes);
};

export const removePlanAccessCode = (uuid) => {
  if (!uuid) return;
  const codes = readCodes();
  if (!codes[uuid]) return;
  delete codes[uuid];
  writeCodes(codes);
};

export const appendPlanAccessHeader = (headers, uuid) => {
  if (!headers || !uuid) return;
  const code = getPlanAccessCode(uuid);
  if (!code) return;
  headers["X-Plan-Access-Code"] = code;
};
